export const heroImage =
  'https://cdn.magicpatterns.com/uploads/iXSev9czqJCvA7mf8uzBRJ/Imagen_de_ChatGPT_30_sept_2026,_23_35_50-Photoroom.webp'

/** Link di pagamento. */
export const checkoutUrl =
  'https://pallavolo-360-sistema-completo-per-allenatori-di-pallavolo.impultienda.ar/checkout'
export const brandName = 'PALLAVOLO 360™'
export const price = '€19'
export const fullPrice = '€197'
export const volumesValue = '€120'
export const bonusValue = '€77'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '6', label: 'Volumi tecnici' },
  { value: '96', label: 'Sessioni pronte' },
  { value: '5', label: 'Bonus esclusivi' },
]

export const heroBadges: string[] = [
  '100% digitale',
  'Accesso immediato',
  'PDF scaricabile',
  'Garanzia 7 giorni',
]

/** Il costo reale di non avere il sistema corretto. */
export interface Cost {
  title: string
  detail: string
}

export const costs: Cost[] = [
  {
    title: 'Ore di preparazione ogni settimana',
    detail:
      "Il lavoro dell'allenatore inizia molto prima di entrare in palestra.",
  },
  {
    title: 'Ripeti gli stessi esercizi',
    detail:
      'Non perché siano sempre la scelta migliore, ma perché sono quelli che ricordi più velocemente.',
  },
  {
    title: 'Esercizi senza una progressione chiara',
    detail:
      'Il giocatore esegue il compito, ma fatica a capire cosa viene prima e cosa viene dopo.',
  },
  {
    title: 'Spieghi troppo e mostri poco',
    detail:
      'Un gesto tecnico è molto più facile da comprendere quando posizione, movimento e traiettoria sono visibili.',
  },
  {
    title: "Vedi l'errore ma devi improvvisare la correzione",
    detail:
      'Piattaforma sbagliata. Arrivo in ritardo. Corpo fuori equilibrio. Direzione imprecisa. Sai che qualcosa non funziona, ma devi decidere rapidamente come intervenire.',
  },
  {
    title: 'Livelli diversi nello stesso gruppo',
    detail:
      'Un esercizio può essere troppo semplice per alcuni e troppo difficile per altri.',
  },
  {
    title: 'Ogni allenamento ricomincia da zero',
    detail: 'Manca una struttura che colleghi una seduta alla successiva.',
  },
]

/** La logica con cui il sistema organizza il lavoro. */
export const systemFlow: string[] = [
  'Gesto',
  'Esercizio',
  'Progressione',
  'Collaborazione',
  'Gioco',
]

/** Cosa include l'accesso completo. */
export const included: string[] = [
  '6 volumi tecnici',
  "96 sessioni pronte all'uso",
  '5 bonus esclusivi',
  'Progressioni illustrate passo dopo passo',
  'Diagrammi e organizzazione del campo',
  'Errori e correzioni',
  '100% digitale',
  'Accesso immediato in PDF',
  'Garanzia di 7 giorni',
]

/** La chiusura: cosa succede se continui a improvvisare e cosa ottieni. */
export interface Outcome {
  text: string
  positive: boolean
}

export const outcomes: Outcome[] = [
  { text: 'Ore a cercare nuovi esercizi', positive: false },
  { text: "Progressioni costruite all'ultimo momento", positive: false },
  { text: 'Spiegazioni lunghe in palestra', positive: false },
  {
    text: 'Giocatori fermi mentre organizzi il prossimo esercizio',
    positive: false,
  },
  {
    text: 'Difficoltà ad adattare il lavoro ai diversi livelli',
    positive: false,
  },
  { text: 'Ogni seduta ricomincia da zero', positive: false },
  { text: '5 minuti per scegliere la struttura della seduta', positive: true },
  {
    text: 'Progressioni dal gesto semplice alla situazione di gioco',
    positive: true,
  },
  { text: 'Esercizi spiegati visualmente', positive: true },
  { text: '96 sessioni già organizzate', positive: true },
  { text: 'Varianti per gruppi e livelli diversi', positive: true },
  { text: 'Più struttura e meno improvvisazione', positive: true },
]
